// Import React
import { useState } from 'react';

// Import Custom UI
import { DefaultText, PasswordText } from '../functions/TextModule'

// Import Custom Functions
import { appFunc, appConfig } from "../functions/FuncHeader";
import { encryptText, validateUserAdminStatus } from '../functions/LoginCheck';

/* =====================================
   D E F I N I T I O N
   ===================================== */

const loginPropList = appFunc.appEnum.createEnum([
    "isUidTaken",
    "isShowPwdTb",
    "isUidTbEmpty",
    "isPwdTbEmpty",
    "uidTbMessage",
    "uidTbValue",
    "pwdTbValue"
]);
const LoginHeader = "LoginPage"

/* =====================================
   F U N C T I O N S
   ==================================== */

export default function Login({getAppConfig, setAppConfig = () => {}})
{
    // Initialise
    const [getLoginProp, setLoginProp] = useState({
        [loginPropList.isUidTbEmpty]:   false,
        [loginPropList.isPwdTbEmpty]:   false,
        [loginPropList.isShowPwdTb]:    false,
        [loginPropList.isUidTaken]:     false,
        [loginPropList.uidTbValue]:     "",
        [loginPropList.pwdTbValue]:     "",
        [loginPropList.uidTbMessage]:   "(Cannot be empty)",
    });

    /* Function: handleKeyDown(event)
       Info: Function to accept key down event for login's textbox 
            to trigger validateLogin
       Returns: void
    */
    const handleKeyDown = (event) => {
        if (event.key === "Enter")
        {
            ValidateLogin()
        }
        else
        {
            // DO NOTHING
        }
    }

    /* Function: ValidateLogin()
       Info: Validate Login's textbox value and trigger 
            the login process is textbox valus is valid.
       Returns: void
    */
    function ValidateLogin()
    {
        let txtUid = getLoginProp[loginPropList.uidTbValue].trim();
        let txtPwd = getLoginProp[loginPropList.pwdTbValue];
        appFunc.updateUseState.object(loginPropList.isUidTbEmpty, txtUid === "", setLoginProp);
        appFunc.updateUseState.object(loginPropList.isPwdTbEmpty, txtPwd === "", setLoginProp);
        if (txtUid !== "" && txtPwd !== "")
        {
            queryApiLogin(txtUid, txtPwd);
        }
        else
        {
            appFunc.dbprint(appFunc.severitiesLevel.PRINT_INFO, LoginHeader, "[validateLogin] Either input are invalid");
        }
    }

    /* Function: clearLoginField()
       Info: Clear all login's textbox field
       Returns: void
    */
    function clearLoginField()
    {
        appFunc.updateUseState.object(loginPropList.isShowPwdTb, false, setLoginProp);
        appFunc.updateUseState.object(loginPropList.uidTbValue, "", setLoginProp);
        appFunc.updateUseState.object(loginPropList.pwdTbValue, "", setLoginProp);
    }

    /* Function: queryApiLogin(txtUid, txtPwd)
       Info: Query UserLogin to Server's API
       Returns: void
    */
    function queryApiLogin(txtUid, txtPwd)
    {
        fetch( process.env.REACT_APP_API_BASE_URL + "/users/sign-in", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "username": txtUid,
                "password": encryptText(txtPwd)
            })
        })
        .then(response => response.json())
        .then(response => {
            // If user do not exist, show error
            if (response["Error"] !== undefined)
            {
                appFunc.updateUseState.object(appConfig.isUserLogin, false, setAppConfig);
                appFunc.updateUseState.object(loginPropList.uidTbMessage, "(Invalid User)", setLoginProp);
            }
            // If user exist, login user and store token and display name
            else if (response["access-token"] !== undefined)
            {
                appFunc.updateUseState.object(appConfig.isUserLogin, true, setAppConfig);
                localStorage.setItem(process.env.REACT_APP_API_ACCESS_TOKEN, response["access-token"]);
                if (response["displayName"] !== undefined)
                {
                    localStorage.setItem(process.env.REACT_APP_API_USER_DISPLAY_NAME, response["displayName"]);
                }
                else
                {
                    // NOTHING TO BE DONE
                }
                clearLoginField();
                validateUserAdminStatus(setAppConfig);

            }
        })
        .catch(error => {
            appFunc.dbprint(appFunc.severitiesLevel.PRINT_ERROR, LoginHeader, `[queryApiLogin] ${error}`);
        });
    };

    return (
        <div className={`LoginPage ${getAppConfig[appConfig.isUserLogin] ? 'hide' : ''}`}>
            <div className="LoginContainer1">
                <div className="defaultTxtContainer2 invalid">
                    <div className={`InvalidTxt ${getLoginProp[loginPropList.isUidTaken] ? "open": ""}`}>Invalid User</div>
                </div>
                <DefaultText
                    txtLabel="Username"
                    txtErrorLabel={getLoginProp[loginPropList.uidTbMessage]}
                    txtErrorToggle={getLoginProp[loginPropList.isUidTbEmpty] || getLoginProp[loginPropList.uidTbMessage] !== "(Cannot be empty)"}
                    inputID="loginTxtUid"
                    inputValue={getLoginProp[loginPropList.uidTbValue]}
                    changeTask={event => appFunc.updateUseState.object(loginPropList.uidTbValue, event.target.value, setLoginProp)}
                    keyDownTask={handleKeyDown}
                    inputDisabled={getAppConfig[appConfig.isUserLogin]}
                />
                <PasswordText
                    txtLabel="Password"
                    txtErrorToggle={getLoginProp[loginPropList.isPwdTbEmpty]}
                    inputID="loginTxtPwd"
                    inputValue={getLoginProp[loginPropList.pwdTbValue]}
                    changeTask={event => appFunc.updateUseState.object(loginPropList.pwdTbValue, event.target.value, setLoginProp)}
                    keyDownTask={handleKeyDown}
                    showPwd={getLoginProp[loginPropList.isShowPwdTb]}
                    showPwdEvent={() => appFunc.updateUseState.object(loginPropList.isShowPwdTb, !getLoginProp[loginPropList.isShowPwdTb], setLoginProp)}
                    inputDisabled={getAppConfig[appConfig.isUserLogin]}
                />
                <div className='defaultTxtContainer2'>
                    <button className="loginSubmit"
                        disabled={getAppConfig[appConfig.isUserLogin]}
                        onClick={() => ValidateLogin()}
                    >
                        Login
                    </button>
                </div>
            </div>
        </div>
    );
}